import {Icon, IconButton} from "@fluentui/react";
import React, {useMemo} from "react";
import {SharedColors} from "@fluentui/theme";
import {SupportPriorityEnum} from "../API";

interface IPriorityIconProps {
    priority: SupportPriorityEnum | string;
    useButton?: boolean;
    disabled?: boolean;
}

export const iconDataFromPriority = (
    priority: SupportPriorityEnum | string,
) => {
    let icon:
        | "ChevronDownSmall"
        | "ChevronUpSmall"
        | "DoubleChevronUp8"
        | "ChevronRightSmall"
        | "" = "";
    let color: string = "";

    if (isNaN(priority as any)) {
        priority = SupportPriorityEnum[priority as any];
    }

    switch (priority) {
        case SupportPriorityEnum.Low:
            icon = "ChevronDownSmall";
            color = SharedColors.yellowGreen10;
            break;
        case SupportPriorityEnum.Medium:
            icon = "ChevronRightSmall";
            color = SharedColors.cyan10;
            break;
        case SupportPriorityEnum.High:
            icon = "ChevronUpSmall";
            color = SharedColors.orange10;
            break;
        case SupportPriorityEnum.Urgent:
            icon = "DoubleChevronUp8";
            color = SharedColors.red10;
            break;
    }

    return {icon, color};
};

export const SupportPriorityIcon = ({
                                        priority,
                                        useButton,
                                        disabled,
                                    }: IPriorityIconProps) => {
    const data: {
        color: string;
        icon: string;
    } = useMemo(() => iconDataFromPriority(priority), [priority]);

    if (useButton) {
        return (
            <IconButton
                disabled={disabled}
                iconProps={{iconName: data.icon}}
                style={{color: data.color}}
            />
        );
    }

    return (
        <Icon iconName={data.icon} style={{color: data.color, fontSize: 16}}/>
    );
};
